var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout',{staticClass:"how-to-play"},[_c('TitleBreadcrumb'),_c('div',{staticClass:"content-base container"},[_c('HowToPlay',{attrs:{"authenticated":_vm.authenticated}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }